<template>
  <!-- Ordenar frase (retorno de 16/10, card 17trt6jcyfb): os exercicios
       "unscramble". O aluno arrasta as palavras para a linha da resposta, ou
       toca na palavra para move-la (no celular arrastar nem sempre e
       confortavel). Na linha, arrastar reordena. -->
  <div class="xow" :class="{ 'is-disabled': disabled }">
    <draggable
      v-model="placed"
      class="xow__line"
      :class="{ 'is-empty': !placed.length }"
      :group="group"
      :disabled="disabled"
      :animation="150"
      ghost-class="xow__ghost"
      tag="div"
      role="list"
      :aria-label="$t('sheet.orderAnswer', { letter })"
      @change="emitValue"
    >
      <button
        v-for="token in placed"
        :key="token.key"
        type="button"
        role="listitem"
        class="xow__token xow__token--placed"
        :disabled="disabled"
        :aria-label="$t('sheet.orderRemove', { word: token.text })"
        @click="unplace(token)"
      >
        {{ token.text }}
      </button>
      <span v-if="!placed.length" slot="footer" class="xow__hint">
        {{ $t("sheet.orderHint") }}
      </span>
    </draggable>

    <draggable
      v-model="pool"
      class="xow__pool"
      :group="group"
      :disabled="disabled"
      :animation="150"
      ghost-class="xow__ghost"
      tag="div"
      role="list"
      :aria-label="$t('sheet.orderWords')"
      @change="emitValue"
    >
      <button
        v-for="token in pool"
        :key="token.key"
        type="button"
        role="listitem"
        class="xow__token"
        :disabled="disabled"
        :aria-label="$t('sheet.orderAdd', { word: token.text })"
        @click="place(token)"
      >
        {{ token.text }}
      </button>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";

let uid = 0;

export default {
  name: "OrderWords",
  components: { draggable },

  props: {
    tokens: { type: Array, default: () => [] },
    // A frase montada ate agora, como lista de textos das pecas.
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    letter: { type: String, default: "" },
  },

  data() {
    uid += 1;
    return {
      group: `xow-${uid}`,
      placed: [],
      pool: [],
    };
  },

  watch: {
    tokens: { immediate: true, handler: "restore" },
    value(next) {
      if (!this.sameAsPlaced(next)) this.restore();
    },
  },

  methods: {
    // Pecas repetidas ("the", "the") sao separadas pela posicao: a resposta
    // guarda o texto, e cada texto volta para a primeira peca livre igual.
    restore() {
      const all = this.tokens.map((text, index) => ({ key: index, text }));
      const free = [...all];
      const placed = [];
      for (const text of this.value || []) {
        const at = free.findIndex((token) => token.text === text);
        if (at > -1) placed.push(free.splice(at, 1)[0]);
      }
      this.placed = placed;
      this.pool = free;
    },

    sameAsPlaced(value) {
      const texts = this.placed.map((token) => token.text);
      return (
        texts.length === (value || []).length &&
        texts.every((text, index) => text === value[index])
      );
    },

    place(token) {
      if (this.disabled) return;
      this.pool = this.pool.filter((item) => item.key !== token.key);
      this.placed = [...this.placed, token];
      this.emitValue();
    },

    unplace(token) {
      if (this.disabled) return;
      this.placed = this.placed.filter((item) => item.key !== token.key);
      // Volta para o lugar de origem, para a bandeja nao "embaralhar de novo".
      this.pool = [...this.pool, token].sort((a, b) => a.key - b.key);
      this.emitValue();
    },

    emitValue() {
      this.$emit(
        "input",
        this.placed.map((token) => token.text)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.xow {
  display: grid;
  gap: 12px;
  margin-top: 6px;
}

/* A linha da resposta, no idioma da folha: tracejada, como as lacunas. */
.xow__line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  padding: 8px 4px;
  border-bottom: 2px dashed var(--fill, var(--dk-pink, #e8276f));
}

.xow__line.is-empty {
  border-bottom-color: var(--dk-line-strong, #d6cfe2);
}

.xow__hint {
  font-size: 13px;
  color: var(--muted, var(--dk-muted, #7a7590));
}

.xow__pool {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 40px;
}

.xow__token {
  padding: 6px 12px;
  border: 1.5px solid var(--dk-line-strong, #ded7ea);
  border-radius: 10px;
  background: var(--dk-surface, #fff);
  font: inherit;
  font-size: 15px;
  color: var(--ink, var(--dk-ink, #2b2540));
  cursor: grab;
  touch-action: none;
  user-select: none;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.xow__token:hover:not(:disabled),
.xow__token:focus-visible {
  border-color: var(--fill, var(--dk-pink, #e8276f));
}

.xow__token:focus-visible {
  outline: 3px solid rgba(232, 39, 111, 0.35);
  outline-offset: 2px;
}

/* O que o aluno ja colocou fica na cor dele. */
.xow__token--placed {
  border-color: var(--fill, var(--dk-pink, #e8276f));
  background: var(--fill-wash, var(--dk-pink-wash, #fdeef4));
  color: var(--fill, var(--dk-pink, #e8276f));
  font-weight: 600;
}

.xow__ghost {
  opacity: 0.4;
}

.xow.is-disabled .xow__token {
  cursor: default;
}
</style>
